import React from 'react';
import { useTranslation } from 'next-i18next';
import styles from './index.module.less';
import { ga_logEvent } from '@/shared/ga';
import { EventName } from '@/shared/event-types';
import { AFFILIATE_SIGNUP_URL } from '../../constants';

// 设计稿 #10899:3819 ~ #10899:3861
// pill 文案入库为句首大写，全大写由 CSS text-transform 实现
const STEPS = [
  {
    no: '01',
    pill: 'Get your link',
    title: 'Get your referral link',
    desc: 'Join the Erasa Affiliate Program for free and get your unique referral link.',
  },
  {
    no: '02',
    pill: 'Share it',
    title: 'Share with creators who need it',
    desc: 'Post your link, send it via DM, or recommend Erasa directly to creators who could benefit.',
  },
  {
    no: '03',
    pill: 'Track it',
    title: 'Track your referrals',
    desc: 'View referrals and commissions in your affiliate dashboard. Eligible purchases made within the 30-day tracking window will be credited to you.',
  },
  {
    no: '04',
    pill: 'Get paid',
    title: 'Get paid',
    desc: 'Commissions are confirmed after 30 days and paid monthly via PayPal, with no minimum payout.',
  },
];

// #10899:3824，12×12 单色图形，内联
const ChevronRight = () => (
  <svg className={styles.chevron} width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
    <path d="M4.5 9L7.5 6L4.5 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

/** How It Works + 底部 CTA：设计稿 #10899:3814 */
const HowItWorks: React.FC<{ isModal?: boolean }> = ({ isModal = false }) => {
  const { t } = useTranslation('common');
  const SectionHeading = isModal ? 'h3' : 'h2';
  const StepHeading = isModal ? 'h4' : 'h3';

  const onApply = () => {
    ga_logEvent(EventName.click_affiliate_invite_cta, { position: isModal ? 'modal_bottom' : 'page_bottom' });
    window.open(AFFILIATE_SIGNUP_URL, '_blank');
  };

  return (
    <section className={styles.container}>
      {/* #10899:3815 */}
      <div className={styles.header}>
        <SectionHeading className={styles.title}>{t('How It Works')}</SectionHeading>
        <p className={styles.subtitle}>{t('Start earning in 4 simple steps')}</p>
      </div>

      {/* #10899:3818 */}
      <ol className={styles.steps}>
        {STEPS.map((step, index) => (
          <li key={step.no} className={styles.step}>
            {/* #10899:3820 */}
            <div className={styles.stepHead}>
              <span className={styles.stepNo}>{step.no}</span>
              {/* 最后一步没有指向下一步的箭头 */}
              {index < STEPS.length - 1 && (
                <span className={styles.arrow} aria-hidden="true">
                  <span className={styles.dash} />
                  <ChevronRight />
                </span>
              )}
            </div>
            <span className={styles.pill}>{t(step.pill)}</span>
            <StepHeading className={styles.stepTitle}>{t(step.title)}</StepHeading>
            <p className={styles.stepDesc}>{t(step.desc)}</p>
          </li>
        ))}
      </ol>

      {/* #10899:3862 */}
      <button type="button" className={styles.cta} onClick={onApply}>
        {t('Apply to Join the Erasa Affiliate Program')}
      </button>
    </section>
  );
};

export default HowItWorks;
